import { useMutation, useQueryClient } from 'react-query';
import { queryKeys } from './queryKeys';
import { TransfersListDTO } from './useTransfersQuery';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';
import { useRouteParams } from '../hooks/useRouteParams';

interface DeleteACHTransferParams {
  transferId: string;
}

const deleteACHTransfer = ({
  clientId,
  managedAccountId,
}: {
  clientId: string;
  managedAccountId: string;
}) => ({ transferId }: DeleteACHTransferParams) =>
  authFetch('/Consumer/AchTransfers/Delete', {
    method: 'DELETE',
    ...httpBodyOptions({ managedAccountId, transferId, clientId }),
  });

export const useDeleteACHTransferMutation = (managedAccountId: string) => {
  const { clientId } = useRouteParams();

  const queryClient = useQueryClient();

  const queryKey = queryKeys.transfers({ clientId, managedAccountId });

  return useMutation(deleteACHTransfer({ clientId, managedAccountId }), {
    onSuccess: (_, { transferId }) => {
      queryClient.setQueryData<TransfersListDTO | undefined>(queryKey, transfersCache => {
        if (transfersCache) {
          return {
            ...transfersCache,
            rejected: transfersCache.rejected.filter(
              transfer => transfer.transferId !== transferId,
            ),
          };
        }

        return transfersCache;
      });
    },
  });
};
